import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
	return <Link to="/remembrance" className="home-button" title="Go back to the Remembrance home screen"><img src="/images/ui/home-button.svg" alt="Back to Remembrance home screen" /></Link>
}

export default Home;